/* Memorygram Legacy Book CRO preview, 2026-09-29.
   - One sticky mobile buy bar that hides whenever the real buy controls are in view
     (and near the footer).
   - Product page: bar mirrors the price the page is showing (after Discount Ninja),
     adds to cart through the real button once the storyteller choice is made,
     otherwise scrolls to that choice.
   - Review stars in the bar open this product's own reviews (never the site-wide popup).
   - Thin rules between consecutive white sections. */
(function () {
  'use strict';

  var marker = document.querySelector('.lbx-page-marker[data-lbx-page]');
  if (!marker) return;
  var page = marker.getAttribute('data-lbx-page');
  var bar = document.querySelector('[data-lbx-sticky]');
  var main = document.querySelector('main') || document.body;

  /* ------------------------------------------------ white-section rules */
  function effectiveBg(section) {
    var nodes = [section].concat(Array.prototype.slice.call(section.querySelectorAll('div, section'), 0, 8));
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.width < section.getBoundingClientRect().width * 0.9) continue;
      var bg = getComputedStyle(nodes[i]).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
    }
    return 'rgb(255, 255, 255)';
  }

  function applyRules() {
    var sections = Array.prototype.filter.call(main.children, function (el) {
      return el.classList.contains('shopify-section') && !el.classList.contains('lbx-section') &&
        el.getBoundingClientRect().height > 20;
    });
    var prevWhite = false;
    sections.forEach(function (s, index) {
      var white = effectiveBg(s) === 'rgb(255, 255, 255)';
      var isApp = /apps|app-section|__17/.test(s.id) || s.querySelector('iframe');
      var isLogos = !!s.querySelector('.mg-media-logos');
      s.classList.toggle('lbx-rule-top', index > 0 && white && prevWhite && !isApp && !isLogos);
      prevWhite = white;
    });
  }

  /* Sticky bar price: the price the page shows, plus the crossed-out original price in
     smaller type beside it when there is one (Larry, 2026-09-30). Both are read from the
     page's own price box (Discount Ninja), never computed. */
  function renderStickyPrice(slot, nowText, wasText, prefix) {
    var money = /[$€£]\s?\d[\d,]*(?:\.\d{2})?/;
    var toNum = function (s) { return parseFloat(String(s).replace(/[^\d.]/g, '')) || 0; };
    var now = (nowText || '').match(money);
    var was = (wasText || '').match(money);
    var nowStr = now ? now[0].replace(/\s/g, '') : '';
    var wasStr = was ? was[0].replace(/\s/g, '') : '';
    if (slot.getAttribute('data-now') === nowStr && slot.getAttribute('data-was') === wasStr) return;
    slot.setAttribute('data-now', nowStr);
    slot.setAttribute('data-was', wasStr);
    slot.textContent = '';
    if (!nowStr) return;
    var n = document.createElement('span');
    n.className = prefix + '-sticky__now';
    n.textContent = nowStr;
    slot.appendChild(n);
    if (wasStr && toNum(wasStr) > toNum(nowStr)) {
      var w = document.createElement('s');
      w.className = prefix + '-sticky__was';
      w.textContent = wasStr;
      slot.appendChild(w);
    }
  }

  /* ------------------------------------------- floating bubbles vs. bottom bars
     Larry 14311 (2026-10-20): on his iPhone Chrome the chat bubble sat on the "Buy Now & Save" button while
     the sticky bar was up. The old lift was a CSS transform keyed to a body class, so it depended on the class
     being present, on beating Zoho's own !important transform, and on the bar being 74 px tall. This helper
     measures instead: whenever a bottom bar or sheet is actually on screen (sticky buy bar, A/B bars, the
     "start with their name" sheet), both the Zoho chat bubble (#zsiq_float, bottom right) and the Tolstoy
     video bubbles (bottom left) are written an inline !important bottom that puts them 12 px above its top;
     when nothing is there they go back to their own spot.
     Larry 14340 (Chrome iOS toolbar sliding in and out): bar and bubbles are all pinned to the bottom edge, so
     the clearance at rest is the bar's own layout height (offsetHeight, which includes the iPhone safe-area
     padding), never a figure derived from innerHeight or the visual viewport, which drift while the toolbar
     animates. The on-screen rectangle is used only while a bar is sliding away (class is-hidden), so the
     bubbles ride down with it.
     Larry 14335 / 14232: while the quiz sheet is open the chat bubble and the Tolstoy bubble are hidden (bar, sheet
     and bubbles together covered most of a short phone screen); both come back when it closes.
     Larry 14337-14339: Tolstoy sometimes renders its bubble widget twice (two stacked bubbles); the first
     visible bubble is kept and lifted, every other one is hidden.
     Homepage A/B groups (html.hpv-A / hpv-B) lift the chat bubble with their own measured CSS rule
     (mt021-hp.css); the helper leaves the chat bubble alone there.
     It re-runs on scroll, resize, visual-viewport changes, the bars' slide transitions (frame by frame) and
     on any DOM or style change (late-loading or re-rendered bubbles). Writes only when the value differs, so
     third-party re-renders cannot start a loop. Same code in legacy-cro.js and medallion-cro.js; the first to
     run installs it. */
  function mgInstallBubbleClearance() {
    if (window.__mgBubbleClearance) return window.__mgBubbleClearance;
    var GAP = 12;
    var BARS = '.lbx-sticky, .mdx-sticky, .v4a-sticky, .v4b-sticky';
    var SHEET = '[data-mq-sheet]';
    var WATCH = BARS + ', ' + SHEET + ', [id^="tolstoy"], tolstoy-widget, tolstoy-bubble, #zsiq_float, body, html';
    var tolBubbles = [], keptTol = null, tolSearched = 0, queued = false, loopUntil = 0;

    function visible(el) {
      if (!el || el.hidden) return false;
      var cs = window.getComputedStyle(el);
      return !(cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05);
    }
    /* like visible() but ignores opacity (the helper itself fades the bubbles out while the quiz sheet is open) */
    function shown(el) {
      if (!el || el.hidden || !el.isConnected) return false;
      var cs = window.getComputedStyle(el);
      return !(cs.display === 'none' || cs.visibility === 'hidden');
    }
    /* height of el above the bottom edge of the screen, 0 when it is not on screen */
    function onScreen(el) {
      if (!visible(el)) return 0;
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      if (r.height <= 0 || r.width <= 0 || r.top >= vh - 1) return 0;
      return vh - r.top;
    }
    function barClearance() {
      var els = document.querySelectorAll(BARS), clear = 0;
      for (var i = 0; i < els.length; i++) {
        var el = els[i], c;
        /* shown: the bar sits at bottom: 0, so its own layout height is the exact clearance, safe-area padding
           included, with no viewport maths (innerHeight, visualViewport and rects are stale for a frame or more
           while Chrome iOS slides its toolbar; the bar and the bubbles are all pinned to the same bottom edge).
           Sliding away (is-hidden): the on-screen rectangle, so the bubbles ride down with it. */
        /* a bar parked off screen by a transform without the class (A/B bars until their hero button scrolls past)
           counts as no bar: the rectangle is only the on/off gate, the value is still offsetHeight */
        if (!el.classList.contains('is-hidden')) c = onScreen(el) > 0 ? el.offsetHeight : 0; else c = onScreen(el);
        if (c > clear) clear = c;
      }
      return clear;
    }
    /* The "start with their name" sheet places itself above the buy bar, but it reads the bar one frame before the
       bar's own show/hide runs, so at the end of a scroll it could sit 60 px behind the bar. Same formula as the
       sheet's own script (bar + 12 px, else 12 px), written here after the bar has updated. */
    function sheetOpen() {
      var sheet = document.querySelector(SHEET);
      return (sheet && !sheet.hidden && sheet.classList.contains('is-open')) ? sheet : null;
    }
    function placeSheet(barClear) {
      var sheet = sheetOpen();
      if (!sheet) return 0;
      var want = (barClear > 0 ? Math.round(barClear + GAP) : 12) + 'px';
      if (sheet.style.bottom !== want) sheet.style.bottom = want;
      /* the sheet is pinned to the bottom edge too: its distance from the edge is its CSS bottom plus its height */
      return sheet.offsetHeight + parseFloat(want);
    }
    function clearance() {
      var barClear = barClearance();
      return Math.max(barClear, placeSheet(barClear));
    }

    /* Tolstoy injects late and has renamed its markup before: a bubble is the outermost fixed element near the
       bottom of the screen inside a Tolstoy host (or its open shadow root). All of them are kept (Larry saw two
       stacked), re-found if Tolstoy re-renders. Searched at most twice a second while none is known, otherwise
       every 2 s (the homepage Tolstoy carousel host has many children). */
    function findTolstoyBubbles() {
      var out = [], seen = [];
      var host0 = document.getElementById('tolstoy-bubble-root');
      var b0 = host0 && host0.shadowRoot && host0.shadowRoot.querySelector('.tolstoy-bubble-container');
      if (b0) out.push(b0);
      var hosts = document.querySelectorAll('[id^="tolstoy"], [class*="tolstoy-bubble"], tolstoy-widget, tolstoy-bubble');
      for (var i = 0; i < hosts.length; i++) {
        var roots = [hosts[i]]; if (hosts[i].shadowRoot) roots.push(hosts[i].shadowRoot);
        for (var k = 0; k < roots.length; k++) {
          var els = [roots[k]].concat([].slice.call(roots[k].querySelectorAll('*')));
          for (var j = 0; j < els.length; j++) {
            var el = els[j]; if (!(el instanceof Element)) continue;
            var inner = false;
            for (var s = 0; s < seen.length; s++) { if (seen[s].contains(el)) { inner = true; break; } }
            if (inner) continue;
            var cs = window.getComputedStyle(el); if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
            var r = el.getBoundingClientRect();
            if (r.width > 0 && r.width < 260 && r.height > 0 && r.height < 320 && r.bottom > window.innerHeight - 260) {
              seen.push(el); if (out.indexOf(el) < 0) out.push(el);
            }
          }
        }
      }
      return out;
    }
    /* Larry 14337-14339: two Tolstoy bubbles stacked bottom-left (Tolstoy's loader ran its bubble widget twice; also
       after a re-render). Keep the first visible bubble, hide every other one; if the kept one is removed later, the
       first one hidden here comes back. */
    function dedupeTolstoy(bubbles) {
      if (bubbles.length > 1) {
        for (var i = 1; i < bubbles.length; i++) {
          var dup = bubbles[i];
          if (dup.style.getPropertyValue('display') !== 'none') { dup.style.setProperty('display', 'none', 'important'); dup.setAttribute('data-mg-duplicate', '1'); }
        }
        keptTol = bubbles[0];
        return [bubbles[0]];
      }
      if (bubbles.length === 1) keptTol = bubbles[0];
      /* nothing visible: bring a hidden duplicate back only when the kept bubble is gone from the DOM (not when
         Tolstoy or the visitor merely closed it) */
      if (!bubbles.length && (!keptTol || !keptTol.isConnected)) {
        var hidden = document.querySelectorAll('[data-mg-duplicate]');
        for (var h = 0; h < hidden.length; h++) {
          if (!hidden[h].isConnected) continue;
          hidden[h].style.removeProperty('display'); hidden[h].removeAttribute('data-mg-duplicate');
          keptTol = hidden[h];
          return [hidden[h]];
        }
      }
      return bubbles;
    }

    function place(el, clear) {
      if (!el) return;
      if (!el.hasAttribute('data-mg-base-bottom')) {
        var own = el.style.getPropertyValue('bottom');
        el.setAttribute('data-mg-base-bottom', el.style.getPropertyPriority('bottom') === 'important' ? '' : own);
      }
      /* the chat bubble follows the bar frame by frame, so it needs no bottom transition of its own; a CSS one
         (the medallion A/B versions fade it with opacity and slide its bottom) would leave it lagging over the
         quiz sheet for half a second while the sheet opens. Keep only the fade. */
      if (el.id === 'zsiq_float') {
        if (el.style.getPropertyValue('transition') !== 'opacity 0.25s') el.style.setProperty('transition', 'opacity 0.25s');
        /* bottom-anchored only: a top value from Zoho would make the bottom value meaningless */
        if (clear > 0 && window.getComputedStyle(el).top !== 'auto' && el.style.getPropertyValue('top') !== 'auto') el.style.setProperty('top', 'auto', 'important');
      }
      var want = clear > 0 ? Math.round(clear + GAP) + 'px' : el.getAttribute('data-mg-base-bottom');
      var cur = el.style.getPropertyValue('bottom');
      /* same value already there (and still !important while lifted: the quiz sheet's close handler rewrites the
         chat bubble's bottom without the priority, which Zoho's own !important rule would then beat) */
      if (want === cur && (clear <= 0 || el.style.getPropertyPriority('bottom') === 'important')) return;
      /* another script already lifted it to about the same place (the quiz sheet lifts the chat by 10 px): leave it */
      if (clear > 0 && /px$/.test(cur) && el.style.getPropertyPriority('bottom') === 'important' && Math.abs(parseFloat(cur) - (clear + GAP)) <= 3) return;
      if (want) el.style.setProperty('bottom', want, 'important'); else el.style.removeProperty('bottom');
    }
    function release(el) {
      if (!el || !el.hasAttribute('data-mg-base-bottom')) return;
      var base = el.getAttribute('data-mg-base-bottom');
      if (base) el.style.setProperty('bottom', base); else el.style.removeProperty('bottom');
      el.removeAttribute('data-mg-base-bottom');
    }
    /* chat bubble (Larry 14335) and Tolstoy bubble (Larry 14232 + 14335: bar, sheet and video covered most of a short
       phone screen) hidden while the quiz sheet is open; only what this helper set is removed again */
    function chatHidden(chat, hide) {
      if (!chat) return;
      var mine = chat.getAttribute('data-mg-hidden') === '1';
      if (hide && !mine) { chat.style.setProperty('opacity', '0', 'important'); chat.style.setProperty('pointer-events', 'none', 'important'); chat.setAttribute('data-mg-hidden', '1'); }
      if (!hide && mine) { chat.style.removeProperty('opacity'); chat.style.removeProperty('pointer-events'); chat.removeAttribute('data-mg-hidden'); }
    }

    function sync() {
      var clear = clearance();
      var chat = document.getElementById('zsiq_float');
      var html = document.documentElement.classList;
      var sheet = sheetOpen();
      /* while the quiz sheet is open the chat bubble is hidden by CSS (html:has([data-mq-sheet].is-open) rule in
         medallion-cro.css) and by the inline fallback below; it is not moved then */
      if (html.contains('hpv-A') || html.contains('hpv-B')) release(chat); else if (!sheet) place(chat, clear);
      chatHidden(chat, !!sheet);
      var alive = 0, live = [];
      for (var i = 0; i < tolBubbles.length; i++) if (shown(tolBubbles[i])) live.push(tolBubbles[i]);
      tolBubbles = live; alive = live.length;
      var every = alive ? 2000 : 500;
      if (Date.now() - tolSearched > every) {
        tolSearched = Date.now();
        var found = dedupeTolstoy(findTolstoyBubbles());
        for (var f = 0; f < found.length; f++) if (tolBubbles.indexOf(found[f]) < 0) loopUntil = Math.max(loopUntil, Date.now() + 1500);
        if (found.length || !alive) tolBubbles = found;
      }
      for (var t = 0; t < tolBubbles.length; t++) if (tolBubbles[t].isConnected) { place(tolBubbles[t], clear); chatHidden(tolBubbles[t], !!sheet); }
    }

    function tick() {
      queued = false;
      try { sync(); } catch (e) { /* never break the page */ }
      if (Date.now() < loopUntil) queue();
    }
    function queue() {
      if (queued) return; queued = true;
      window.requestAnimationFrame(tick);
    }
    function follow() { loopUntil = Math.max(loopUntil, Date.now() + 450); queue(); }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', follow);
    window.addEventListener('orientationchange', follow);
    window.addEventListener('pageshow', follow);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', follow);
      window.visualViewport.addEventListener('scroll', queue);
    }
    ['transitionrun', 'transitionstart', 'transitionend', 'transitioncancel', 'animationstart', 'animationend'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        var el = e.target;
        if (el && el.closest && el.closest(WATCH)) follow();
      }, true);
    });
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (muts[i].type === 'childList' && t && t.closest && t.closest('[id^="tolstoy"], tolstoy-widget, tolstoy-bubble, body')) tolSearched = 0;
          if (muts[i].type === 'childList' || (t && t.closest && t.closest(WATCH))) { queue(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    }
    [0, 600, 2000, 5000, 9000, 15000, 30000, 45000, 60000, 90000].forEach(function (d) { window.setTimeout(follow, d); });
    window.__mgBubbleClearance = { sync: follow, clearance: clearance };
    return window.__mgBubbleClearance;
  }
  var mgBubbles = mgInstallBubbleClearance();

  /* ------------------------------------------------------- sticky bar */
  if (bar) {
    // Rendered inside a section/block; fixed positioning must not depend on ancestors.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var buyButton = bar.querySelector('[data-lbx-sticky-buy]');
    var priceSlot = bar.querySelector('[data-lbx-sticky-price]');
    var watched = [];
    var inView = new Set();

    if (page === 'product') {
      var mp = document.querySelector('[id^="MainProduct-"]');
      if (mp) {
        ['.legacy-book-fields', '.product-form__buttons', '[id^="VariantPickerWrapper-"]',
          '.additional-storytellers-fields'].forEach(function (sel) {
          var el = mp.querySelector(sel);
          if (el) watched.push(el);
        });
      }
    } else {
      Array.prototype.forEach.call(main.querySelectorAll('.mg-btn, .rich-text__buttons .button, .video-with-text .button'),
        function (el) { watched.push(el); });
    }
    var footer = document.querySelector('footer, .footer, [id*="__footer"]');
    if (footer) watched.push(footer);

    /* The bar waits until the visitor has scrolled past the hero (landing pages) or past
       the real Add to cart button (product pages), so it never greets them on arrival
       (Larry, 2026-09-30). */
    var heroEl = page === 'product'
      ? (mp && mp.querySelector('.product-form__buttons'))
      : document.querySelector('#mg-fast-hero');
    function pastHero() {
      if (!heroEl) return true;
      return heroEl.getBoundingClientRect().bottom < 0;
    }
    var heroTicking = false;
    window.addEventListener('scroll', function () {
      if (heroTicking) return;
      heroTicking = true;
      window.requestAnimationFrame(function () { heroTicking = false; update(); });
    }, { passive: true });

    function update() {
      var show = inView.size === 0 && pastHero();
      bar.classList.toggle('is-hidden', !show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('lbx-sticky-on', show && window.matchMedia('(max-width: 989px)').matches);
      mgBubbles.sync();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) inView.add(e.target); else inView.delete(e.target);
        });
        update();
      }, { rootMargin: '0px 0px -40px 0px' });
      watched.forEach(function (el) { io.observe(el); });
    } else {
      bar.classList.remove('is-hidden');
    }

    /* Price mirror. Discount Ninja replaces the theme price with the discounted price,
       but only re-renders while the price box is on screen. So the bar shows DN's
       discounted price when present, stays blank while DN is pending after a variant
       change, and falls back to the theme price only if DN never renders at all. */
    if (priceSlot) {
      var priceBox = document.querySelector('[id^="MainProduct-"] [id^="price-"]');
      var money = /[$€£]\s?\d[\d,]*(?:\.\d{2})?/;
      var dnSeen = false;
      var dnGaveUp = false;
      var syncPrice = function () {
        if (!priceBox) return;
        var dn = priceBox.querySelector('.limoniapps-discountninja-productprice-replaced .limoniapps-discountninja-shortcode-discounted_price');
        var text = '';
        var was = null;
        if (dn) {
          dnSeen = true;
          text = dn.textContent;
          was = priceBox.querySelector('.limoniapps-discountninja-productprice-replaced .limoniapps-discountninja-shortcode-original_price');
        } else if (!dnSeen && dnGaveUp) {
          var last = priceBox.querySelector('.price__sale .price-item--last, .price__regular .price-item--regular');
          text = last ? last.textContent : priceBox.innerText;
          was = priceBox.querySelector('.price__sale .price-item--regular');
        }
        renderStickyPrice(priceSlot, text, was ? was.textContent : '', 'lbx');
      };
      syncPrice();
      if (priceBox && 'MutationObserver' in window) {
        new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
      }
      window.setTimeout(function () { dnGaveUp = true; syncPrice(); }, 8000);
    }

    function scrollToEl(el) {
      var header = document.querySelector('.section-header, sticky-header');
      var offset = header ? Math.min(header.getBoundingClientRect().height, 120) + 16 : 16;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    }

    if (page === 'product' && buyButton) {
      buyButton.addEventListener('click', function () {
        var mp = document.querySelector('[id^="MainProduct-"]');
        if (!mp) return;
        var fields = mp.querySelector('.legacy-book-fields');
        var chosen = mp.querySelector('input[name="properties[Who will be telling stories?]"]:checked');
        var realButton = mp.querySelector('.product-form__buttons [name="add"]');
        if (chosen && realButton && !realButton.disabled) {
          realButton.click();
          window.setTimeout(function () {
            var err = document.querySelector('.email-validation-error, .product-form__error-message-wrapper:not([hidden])');
            if (err) scrollToEl(err);
          }, 250);
          return;
        }
        if (fields) {
          scrollToEl(fields);
          fields.classList.remove('lbx-attention');
          void fields.offsetWidth;
          fields.classList.add('lbx-attention');
          var first = fields.querySelector('input[type="radio"]');
          window.setTimeout(function () { if (first) first.focus({ preventScroll: true }); }, 450);
        }
      });
      /* Larry 2026-10-06: on the product page, the How It Works "Buy Now & Save" button (.hiw2__btn) does exactly what the
         floating button does instead of reloading the page. Homepage (page 'home') never reaches this block. */
      document.addEventListener('click', function (e) {
        var hiw = e.target.closest && e.target.closest('.hiw2__btn');
        if (!hiw) return;
        e.preventDefault();
        buyButton.click();
      });
    }

    update();
  }

  /* ------------------------------------------- review stars -> Loox popup */
  /* The bar shows THIS product's rating and count, so the stars must open THIS
     product's reviews, never the site-wide popup with a different total (Larry,
     2026-09-30). Product page: scroll to the on-page product reviews. Landing page:
     go to the product page's reviews. */
  function scrollToProductReviews() {
    var tries = 0;
    (function attempt() {
      var reviews = document.getElementById('looxReviews');
      if (reviews && reviews.offsetHeight > 40) {
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (tries++ < 20) {
        window.setTimeout(attempt, 250);
      }
    })();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-lbx-open-reviews]');
    if (!trigger) return;
    e.preventDefault();
    if (window.MGReviewsPopup && window.MGReviewsPopup.open()) return;   /* Larry 14478 (Oct 20 2026): every page with review stars gets the reviews popup; the page stays where it is */
    if (document.getElementById('looxReviews')) {
      scrollToProductReviews();
      return;
    }
    var buy = document.querySelector('a[data-lbx-sticky-buy]');
    var target = buy && buy.getAttribute('href');
    if (target) window.location.href = target.split('#')[0] + '#mg-reviews';
  });

  if (window.location.hash === '#mg-reviews') {
    window.setTimeout(scrollToProductReviews, 600);
  }

  function ready() {
    applyRules();
    window.setTimeout(applyRules, 2500);
  }
  if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready);
})();
/* Review stars -> popup (Larry 14208, Oct 20 2026): open the reviews that are already on this page in an
   overlay, without scrolling the visitor away from where they are in the page. The on-page Loox block is lifted
   into the overlay in place (no DOM move, so its frame does not reload) and a same-height placeholder keeps
   the page from shifting; closing puts everything back. */
window.MGReviewsPopup = window.MGReviewsPopup || (function () {
  function open() {
    var r = document.getElementById('looxReviews');
    if (!r || r.classList.contains('mg-rev-pop')) return !!r;
    var ph = document.createElement('div');
    ph.style.height = r.offsetHeight + 'px';
    r.parentNode.insertBefore(ph, r);
    var bd = document.createElement('div'); bd.className = 'mg-rev-backdrop';
    var x = document.createElement('button'); x.type = 'button'; x.className = 'mg-rev-close'; x.setAttribute('aria-label', 'Close reviews'); x.innerHTML = '&times;';
    document.body.appendChild(bd); document.body.appendChild(x);
    r.classList.add('mg-rev-pop'); r.scrollTop = 0;
    document.documentElement.classList.add('mg-rev-open');
    function esc(e) { if (e.key === 'Escape') close(); }
    function close() {
      r.classList.remove('mg-rev-pop'); document.documentElement.classList.remove('mg-rev-open');
      ph.remove(); bd.remove(); x.remove(); document.removeEventListener('keydown', esc);
    }
    bd.addEventListener('click', close); x.addEventListener('click', close); document.addEventListener('keydown', esc);
    return true;
  }
  return { open: open };
})();

/* Larry 14491 (Oct 21 2026): the popup opens only when Loox has rendered reviews on this page. Matched by the Loox widgets,
   never by the count text: the reviews block must hold an iframe with real height (0 reviews, or not loaded yet, leaves it
   at 0), and if the page has a Loox product-box rating widget (.product__info-container .loox-rating) it must not be empty
   (Loox leaves it empty at 0 reviews). Wraps whichever MGReviewsPopup copy loaded first (mt021-hp.js loads before this file
   on every page and wins the ||), so the guard applies to every trigger. When it returns false the triggers keep their old
   behaviour: sticky stars scroll as before, the rating link stays a native anchor; nothing opens, nothing breaks. */
(function () {
  var P = window.MGReviewsPopup;
  if (!P || P.mgGuard14491) return;
  var orig = P.open;
  P.open = function () {
    var r = document.getElementById('looxReviews');
    if (!r) return false;
    if (r.classList.contains('mg-rev-pop')) return orig.apply(this, arguments);
    var fr = r.querySelector('iframe');
    if (!fr || fr.offsetHeight < 1) return false;
    var rating = document.querySelector('.product__info-container .loox-rating');
    if (rating && rating.offsetHeight < 1 && rating.children.length === 0) return false;
    return orig.apply(this, arguments);
  };
  P.mgGuard14491 = true;
})();

/* Larry 14478 (Oct 20 2026): every page with review stars gets the reviews popup; the page stays where it is. Loox's own product-info rating (a[href="#looxReviewsFrame"], "Scroll to reviews") opens the same popup
   instead of jumping to the bottom of the page. Capture phase so Loox's anchor never runs; if the popup cannot open
   (no on-page reviews block) the link is left alone and scrolls as before. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#looxReviewsFrame"]');
  if (!a) return;
  if (window.MGReviewsPopup && window.MGReviewsPopup.open()) { e.preventDefault(); e.stopPropagation(); }
}, true);
